import { appstr } from "./appstr";
import { isBlockedField, getBlockedFieldDisplayValue } from "./FormatFieldValue";

export function FormatEmployeeLabelValue(result, value, index, isLastField, separator = "") {
  const blocked = isBlockedField(value);
  if (blocked) value = getBlockedFieldDisplayValue();
  if (!value) value = "<" + appstr("None") + ">";
  if (index === 1) result += blocked ? value : "(" + value + ")";
  else if (value != null) result += value;
  if (!isLastField) result += separator.trim() + " ";
  return result;
}
